function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.6287 14.2816L26.4188 12.0186C25.8372 11.6086 25.0333 12.0261 25.0333 12.7369V14.121H9.62085C9.13546 14.121 8.74188 14.5145 8.74188 15C8.74188 15.4854 9.13546 15.8789 9.62085 15.8789H25.0332V17.2629C25.0332 17.9785 25.8414 18.3882 26.4186 17.9813L29.6286 15.7183C30.1188 15.3729 30.1287 14.6348 29.6287 14.2816Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.2229 20.6436C24.8029 20.4007 24.2651 20.5441 24.022 20.9644C21.9574 24.5337 18.098 26.9299 13.6877 26.9299C7.10959 26.9299 1.75787 21.5781 1.75787 15.0001C1.75787 8.42197 7.10959 3.07025 13.6877 3.07025C18.1009 3.07025 21.9585 5.46867 24.0219 9.03562C24.265 9.45585 24.8029 9.59923 25.2229 9.35636C25.643 9.11332 25.7866 8.5756 25.5436 8.15543C23.169 4.05046 18.7341 1.31238 13.6877 1.31238C6.12246 1.31238 0 7.4342 0 15.0001C0 22.5653 6.12182 28.6877 13.6877 28.6877C18.7363 28.6877 23.1701 25.9477 25.5437 21.8446C25.7866 21.4244 25.6431 20.8867 25.2229 20.6436Z",
  fill: "white"
}));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.3f261d2d.svg";
export { ForwardRef as ReactComponent };